export const ru = {
    access: 'Права доступа',
    cancel: 'Отмена',
    save: 'Сохранить'
};
